<template>
    <nav class="navbar navbar-light bg-white fixed-top py-1 shadow">
        <!-- Sidebar Toggle (Topbar) -->
        <button id="sidebarToggleTop" class="btn btn-link d-md-none d-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
        </button>

        <router-link to="/home" class="row pl-2 align-items-center">
            <img
                src="../assets/logo.png"
                height="20"
                style="margin-top: 5px; margin-bottom: 5px"
                class="d-inline-block align-top mr-1"
                alt=""
            />
            <span class="ml-2 font-weight-bold small text-secondary">
                Thorpe Coletor
            </span>
        </router-link>

        <div class="ml-auto ml-md-4 ml-lg-4 small text-secondary">
            <em class="fa fa-database ml-2 mr-2"></em>
            <span class="small">
                {{ this.labelBase }}
            </span>
        </div>

        <button
            class="btn btn-link ml-auto text-secondary"
            data-toggle="modal"
            data-target="#logoutModal"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <i class=" fa fa-power-off"></i>
        </button>

        <!-- Nav Item - Dashboard -->
        <div class="collapse navbar-collapse " id="navbarSupportedContent">
            <!-- Topbar Navbar -->
            <ul class="navbar-nav ml-auto">
                <div class="dropdown-divider border-gray"></div>
                <div class="dropdown-divider border-gray"></div>

            </ul>
        </div>
    </nav>
</template>

<script>
import api from '../services/api'
import { getUsername, getPerfil, BASES, getBase } from "../services/api";
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'

export default {
    name: "Topbar",
    computed: {
        username: function() {
            return getUsername().split(" ")[0];
        },
    },

    data: () => {
        return {
            menus : [],
            base: getBase(),
            labelBase: ""
        }
    },

    async mounted() {
        await this.getMenus();

        try {
            await this.validarToken();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }
    },

    methods: {
        getUsername,
        getPerfil,

        async validarToken() {
            this.carregando = true;

            await api.get("/validar-token");

            this.carregando = false;
        },

        async getMenus() {
            this.carregando = true;
            this.labelBase = BASES[getBase()].label;

            if (!sessionStorage.getItem("menus")) {
                if (getPerfil() != 'null') {
                    let response = await api.post("/menus", {
                        idPerfil: getPerfil()
                    });

                    this.menus = response.data;
                    sessionStorage.setItem("menus", JSON.stringify(response.data));
                }
            } else {
                this.menus = JSON.parse(sessionStorage.getItem("menus"));
            }
            this.carregando = false;
        },

        
    }
};
</script>


<style lang="scss" scoped>
    a.disabled {
        opacity: 0.5;
    }

    a {
        font-size: 0.95em;
    }
    a.dropdown-item {
        color: var(--gray) !important;
    }
    a.dropdown-item:active {
        color: var(--white) !important;
    }
</style>
